// shame.js

(function ($) {

  //NOOP
const quotes= document.querySelectorAll(".quote .quote-blockquote p");
  if (quotes.length > 0) {
    for (const quote of quotes) {
      quote.textContent= quote.textContent.trim();
     if(quote.textContent.startsWith('"')) {
      quote.textContent= quote.textContent.slice(1, quote.textContent.length);
      }
      if(quote.textContent.endsWith('"')) {
        quote.textContent= quote.textContent.slice(0,-1);
      }
    }
  }
})(window.jQuery);
